import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isDate.js
// module id = 846
// module chunks = 115